import Card from "components/card";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MdOutlineMoreTime } from "react-icons/md";
import { useSelector } from "react-redux";
import { currentUser } from "services/users/authSlice";
import { ESService } from "services/esService";
import ApiList from "services/apiList";

const Shifts = () => {
  const mount = useRef(true);
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const columnsData = ["№", "Нэр", "Эхлэх цаг", "Дуусах цаг"];
  var user = useSelector(currentUser);
  useEffect(() => {
    if (mount.current) {
      mount.current = false;
      const token = user.token;
      const es = new ESService(token);
      es.get(ApiList.shiftUrl,"").then((json) => {
        if (json["status"]) {
          setTableData(json["data"]);
        }
      });
    }
  }, [user]);

  return (
    <Card extra={"w-full h-full p-4  mt-4"}>
      <div className="relative mb-4 flex items-center justify-end">
        <button
          onClick={() => {
            navigate("/admin/shift_detail", { state: { type: "register" } });
          }}
          className={`flex items-center text-xl hover:cursor-pointer ${"bg-lightPrimary p-2 text-brand-500 hover:bg-gray-100 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10"} linear justify-center rounded-lg font-bold transition duration-200`}
        >
          <MdOutlineMoreTime className="h-6 w-6" />
        </button>
      </div>

      <div className="h-full overflow-x-scroll xl:overflow-hidden">
        <table className="responsive_table">
          <thead>
            <tr key={"sh-header"}>
              {columnsData.map((column, index) => (
                <th key={"user-header" + index}>{column}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableData.map((row, i) => {
              return (
                <tr key={i}>
                  <td data-label="№">{i + 1}</td>
                  <td data-label="Нэр">
                    <button
                      onClick={() => {
                        navigate("/admin/shift_detail", {
                          state: { type: "edit", data: row },
                        });
                      }}
                      className="text-blue-800 underline hover:text-blue-600 dark:text-white "
                    >
                      {row.name}
                    </button>
                  </td>
                  <td data-label="Эхлэх цаг">{row.start}</td>
                  <td data-label="Дуусах цаг">{row.end}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Card>
  );
};

export default Shifts;
